export default "__VITE_ASSET__DHFZEQHc__"